import React from 'react';
import stl from './Btn.module.css';

const Btn = ({ onClick, disabled, icon, label, className = '' }) => {

    return (
        <button disabled={disabled }onClick={onClick}
                className={`${stl.btn} ${disabled ? stl.btnDisabled : ''} ${className}`}>
            {icon && (
                <span className={stl.icon}>
                    {typeof icon === 'function' || typeof icon === 'object' ? (
                        icon
                    ) : (
                        <img src={icon} alt="icon" className={stl.iconImage} />
                    )}
                 </span>
            )}
            {label}
        </button>
    );
};

export default Btn;
